<app-layout-default>
  <div>
    <h1 class="c11n-text-2xl-headline margin-bottom-2" [innerHTML]="content.pageTitle" data-cy="pageTitle"></h1>
    <p class="c11n-text-md margin-bottom-2" [innerHTML]="content.pageDescription" data-cy="pageDescription"></p>
    <pbj-ready-to-enroll
      [includeManuallyAddedAccounts]="true"
      (accountsSelectedForEnrollmentEvent)="handleSelectedAccountsToEnroll($event)"
      (pbjError)="errorHandler($event)">
    </pbj-ready-to-enroll>
    
    <div class="margin-top-2">
      <p class="margin-bottom-8" [innerHTML]="content.mfeFooter"></p>
      <section data-cy="disclaimer" class="disclaimers-wrapper">
        <div class="c11n-text-sm taxes-disclaimers-wrapper">
          <span [innerHTML]="commonContent.disclaimer.part1"></span>
          <span [innerHTML]="commonContent.disclaimer.part2"></span>
          <a c11n-link variant="secondary-reinforced" [fontWeight]="'normal'" [href]="commonContent.disclaimer.linkHref">
            {{ commonContent.disclaimer.linkText }}</a>
          <span [innerHTML]="commonContent.disclaimer.part3"></span>
          <span [innerHTML]="content.disclaimerFooter"></span>
        </div>
      </section>
    </div>
    <onb-mfe-secure-link></onb-mfe-secure-link>
  </div>

  <div layout-last-column>
    <c11n-button variant="primary" id="multiAccountEnrollmentContinueBTN" [labelText]="commonContent.continueButton" size="medium"
      [fullWidth]="true" (clickEvent)="nextPage()">
    </c11n-button>
    <app-cancel [isOpenChoice]="true" id="multiAccountEnrollmentContinueBTN"></app-cancel>
  </div>
</app-layout-default>